import { PanelItem } from '../panel-item.class';
import { PanelItems } from '../panel-items.class';

type FilterPanelItemsOptions = {
	withCountertopItems: boolean,
	includePlacements: Array<string>
};

export const filterPanelItemsCfn = (panelItems: PanelItems | undefined, options: FilterPanelItemsOptions): Array<PanelItem> => {
	const { withCountertopItems = false, includePlacements = [] } = options;
	if (typeof panelItems === 'undefined') return [];

	let items = panelItems.children as unknown as Array<PanelItem>;

	if (includePlacements.length > 0) items = items.filter((i) => includePlacements.indexOf(i.item.placement) > -1);

	return items
		.filter((panelItem) => {
			if (panelItem.item === null || panelItem.item.exclude) return false;

			// if (['custom', 'cutout'].indexOf(panelItem.item.category) === -1 && panelItem.item.sku !== 'CUTOUT') {
			// 	return !panelItem.item.exclude && withCountertopItems
			// 		? panelItem.item.placement.indexOf('top') !== -1
			// 		: true;
			// }

			return !withCountertopItems || panelItem.boundTop;
			// return !withCountertopItems || panelItem.item.placement.indexOf('top') !== -1;
		})
		.sort((a, b) => a.center.y - b.center.y);
};
